// @flow
import * as React from 'react'
import HourlyIcon from 'mz-icons/hourly'
import moment from 'moment'
import getTimeString from 'mz-utils/getTimeString'
import SelectField from '../SelectField'

import type { Props as BaseFieldProps } from '../../core/BaseField'

export type Props = BaseFieldProps & {
  minHours: number,
  maxHours: number,
}

class RideDurationField extends React.Component<Props> {
  static defaultProps = {
    minHours: 1,
    maxHours: 10,
  }

  getOptions = (): Array<number> => {
    const { minHours, maxHours } = this.props
    const options = Array(maxHours - minHours + 1)
      .fill()
      .map((_, index) => minHours + index)

    return options
  }

  renderOption = (numHours: number): React.Node => {
    const numHoursFormatted = getTimeString({
      m: moment(),
      hourDiff: numHours,
    })

    return numHoursFormatted
  }

  render() {
    return (
      <SelectField
        {...this.props}
        emptyValue={null}
        cleanable={false}
        options={this.getOptions()}
        renderPrefix={() => <HourlyIcon />}
        renderOption={this.renderOption}
      />
    )
  }
}

export default RideDurationField
